<template>
  <div>
    <v-layout>
      <v-flex xs12 sm12 md12 lg8 offset-lg2>
        <v-container fluid>
          <v-card>
            <v-card-title>
              <h3>Escola {{ $route.params.schoolId }}</h3>
              <v-spacer></v-spacer>
              <v-btn class="red white--text" @click.native.stop="dialogDelete = true"><v-icon>delete</v-icon></v-btn>
            </v-card-title>
            <v-form v-model="valid" ref="form">
              <v-layout wrap>
                <v-flex xs8 offset-xs2>
                  <v-text-field
                    :label="$t('school.NAME')"
                    v-model="school.name"
                    required
                  ></v-text-field>
                </v-flex>
                <!-- Reemplazar SchoolTypeField por Faculty -->
                <v-flex xs8 offset-xs2>
                  <v-text-field
                    :label="$t('school.FACULTY')"
                    v-model="school.faculty"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs8 offset-xs2>
                  <language-text-field v-model="school.language"></language-text-field>
                </v-flex>
                <v-flex xs8 offset-xs2>
                  <v-text-field
                    :label="$t('school.TOWN')"
                    v-model="school.town"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs8 offset-xs2>
                  <v-text-field
                    :label="$t('school.COUNTRY')"
                    v-model="school.country"
                    required
                  ></v-text-field>
                </v-flex>
                <v-btn fab large bottom right fixed class="green white--text" :disabled="!validForm" @click.native="submit"><v-icon>save</v-icon></v-btn>
              </v-layout>
            </v-form>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Schools' })"><v-icon>arrow_back</v-icon></v-btn>
    <v-layout row justify-center>
      <v-dialog v-model="dialogDelete" persistent>
        <v-card>
          <v-card-title class="headline">{{ $t('dialogs.deleteSchool.HEADER') }}</v-card-title>
          <v-card-text>{{ $t('dialogs.deleteSchool.MESSAGE') }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="green--text darken-1" flat="flat" @click.native="dialogDelete = false">{{ $t('dialogs.deleteSchool.CANCEL') }}</v-btn>
            <v-btn class="red white--text darken-1" flat="flat" @click.native="deleteSchool">{{ $t('dialogs.deleteSchool.OK') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
  import { SchoolResource } from '../../api/school'
  import LanguageTextField from '../common/LanguageTextField'

  export default {
    components: {
      LanguageTextField
    },
    name: 'school',
    data () {
      return {
        school: {
          name: '',
          postalAddress: '',
          faculty: '',
          language: '',
          town: '',
          country: '',
          schoolType: 4
        },
        dialogDelete: false,
        valid: false
      }
    },
    created: function () {
      SchoolResource().get({id: this.$route.params.schoolId}).then(response => {
        console.log(response.body)
        this.school = response.body
        this.validate()
      }, response => {

      })
    },
    mounted: function () {
    },
    computed: {
      validForm: function () {
        return (this.school.name !== '' &&
          this.school.faculty !== '' &&
          this.school.language !== '' &&
          this.school.town !== '' &&
          this.school.country !== '')
      }
    },
    methods: {
      validate: function () {
        this.$refs.form.validate()
      },
      submit: function () {
        SchoolResource().update({id: this.$route.params.schoolId}, this.school).then(response => {
          console.log(response)
          this.$router.push({ name: 'Schools' })
        }, response => {
          console.log(response)
        })
      },
      deleteSchool: function () {
        SchoolResource().remove({id: this.$route.params.schoolId}).then(response => {
          console.log(response)
          this.dialogDelete = false
          this.$router.push({ name: 'Schools' })
        }, response => {
          console.log(response)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/schools/School.vue